import { Component, OnInit } from '@angular/core';
import { TipStrucnogUsavrsavanja } from './tip-strucnog-usavrsavanja';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-tipstrucnogusavrsavanja-modal-update',
  templateUrl: './tip-strucnog-usavrsavanja-modal-update.component.html'
})
export class TipStrucnogUsavrsavanjaModalUpdateComponent extends BaseModalUpdateComponent<TipStrucnogUsavrsavanja> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<TipStrucnogUsavrsavanja>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }


  ngOnInit() {
  }

}
